/**
 * Support / contact-us client — posts the categorized message to the API, which
 * emails it to our AI CRM intake as a lead/ticket. Uses the shared apiRequest
 * wrapper (baked VITE_API_URL base, `{ data }` envelope unwrapping, ApiError).
 */
import { apiRequest } from './api';

export type SupportCategory = 'improvement' | 'bug' | 'subscription' | 'notification' | 'other';

/** A pre-set subject (`company_data` — «Скрыть телефон или исправить данные»). */
export type SupportTopic = 'company_data';

export interface SupportMessageInput {
  category: SupportCategory;
  message: string;
  email: string;
  name?: string;
  /** With `topic: 'company_data'` the API requires the company's `tin`; the
   *  ticket's subject names it and `support_submitted` carries `topic`. */
  topic?: SupportTopic;
  tin?: string;
}

export async function sendSupportMessage(input: SupportMessageInput): Promise<{ ok: boolean }> {
  return apiRequest<{ ok: boolean }>('/support', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
